import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "../components/header";
import Footer from "../components/footer";

export default function NotFound() {
    return (
        <>
            <Helmet>
                <title>
                    Seite nicht gefunden - 404 | DeutschAssist Karolina
                    Zielinska
                </title>
                <meta
                    name="description"
                    content="Die gesuchte Seite wurde nicht gefunden. Kehren Sie zur Startseite zurück."
                />
                <meta name="robots" content="noindex, follow" />
            </Helmet>

            <Header />

            <section className="custom-screen min-h-[70vh] flex items-center justify-center py-16">
                <div className="w-full max-w-3xl text-center">
                    {/* 404 Number */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5 }}
                        className="mb-8"
                    >
                        <h1 className="text-[15vmin] md:text-[20vmin] font-bold leading-none text-text/10">
                            404
                        </h1>
                    </motion.div>

                    {/* Main Content */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        className="space-y-6"
                    >
                        <h2 className="text-2xl md:text-4xl font-bold">
                            Seite nicht gefunden
                        </h2>

                        <p className="text-lg text-text/80 max-w-[56ch] mx-auto">
                            Die Seite, die Sie suchen, existiert nicht oder
                            wurde verschoben.
                        </p>

                        <p className="text-text/60 max-w-[48ch] mx-auto">
                            Bitte überprüfen Sie die URL oder kehren Sie zur
                            Startseite zurück, um fortzufahren.
                        </p>
                    </motion.div>

                    {/* Action Buttons */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                        className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center"
                    >
                        <Link
                            to="/"
                            className="px-6 py-3 bg-primary text-bg rounded-full hover:bg-primary/90 transition-colors min-w-[200px]"
                        >
                            Zur Startseite
                        </Link>
                        <Link
                            to="/kooperationen"
                            className="px-6 py-3 bg-text text-bg rounded-full hover:bg-text/90 transition-colors min-w-[200px]"
                        >
                            Kooperationen ansehen
                        </Link>
                    </motion.div>

                    {/* Additional Help */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.6, delay: 0.6 }}
                        className="mt-16 pt-8 border-t border-text/20"
                    >
                        <p className="text-sm text-text/60 mb-4">
                            Hilfreiche Links:
                        </p>
                        <nav className="flex flex-wrap justify-center gap-4 text-sm">
                            <a
                                href="/#dienstleistungen"
                                className="text-text hover:text-primary transition-colors"
                            >
                                Dienstleistungen
                            </a>
                            <span className="text-text/20">•</span>
                            <a
                                href="/#fur-wen"
                                className="text-text hover:text-primary transition-colors"
                            >
                                Für wen?
                            </a>
                            <span className="text-text/20">•</span>
                            <a
                                href="/#uber-mich"
                                className="text-text hover:text-primary transition-colors"
                            >
                                Über mich
                            </a>
                            <span className="text-text/20">•</span>
                            <a
                                href="/#kontakt"
                                className="text-text hover:text-primary transition-colors"
                            >
                                Kontakt
                            </a>
                        </nav>
                    </motion.div>

                    {/* Decorative Element */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8, delay: 0.8 }}
                        className="mt-12"
                    >
                        <img
                            src="/rect-deco.svg"
                            className="mx-auto opacity-30"
                            aria-hidden="true"
                            alt="Dekorationselement"
                        />
                    </motion.div>
                </div>
            </section>

            <Footer />
        </>
    );
}
